module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "statistic-panel"
  }, [_c('el-row', [_c('el-col', {
    staticClass: "statistic-item text-center",
    attrs: {
      "xs": 12,
      "sm": 6
    }
  }, [_c('div', [_c('div', [_c('i', {
    staticClass: "material-icons assess-color"
  }, [_vm._v("assessment")])]), _vm._v(" "), _c('div', [_c('translate', [_vm._v("Resource")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "count assess-color"
  }, [_vm._v(_vm._s(_vm.statistic.resources + _vm.statistic.shared_resources || 0))])], 1)])]), _vm._v(" "), _c('el-col', {
    staticClass: "statistic-item text-center",
    attrs: {
      "xs": 12,
      "sm": 6
    }
  }, [_c('div', [_c('div', [_c('i', {
    staticClass: "material-icons work-color"
  }, [_vm._v("dvr")])]), _vm._v(" "), _c('div', [_c('translate', [_vm._v("WorkGroup")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "count work-color"
  }, [_vm._v(_vm._s(_vm.statistic.projects || 0))])], 1)])]), _vm._v(" "), _c('el-col', {
    staticClass: "statistic-item text-center",
    attrs: {
      "xs": 12,
      "sm": 6
    }
  }, [_c('div', [_c('div', [_c('i', {
    staticClass: "material-icons cluster-color"
  }, [_vm._v("view_list")])]), _vm._v(" "), _c('div', [_c('translate', [_vm._v("Cluster")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "count cluster-color"
  }, [_vm._v(_vm._s(_vm.statistic.networks || 0))])], 1)])]), _vm._v(" "), _c('el-col', {
    staticClass: "statistic-item text-center",
    attrs: {
      "xs": 12,
      "sm": 6
    }
  }, [_c('div', [_c('div', [_c('i', {
    staticClass: "material-icons member-color"
  }, [_vm._v("group")])]), _vm._v(" "), _c('div', [_c('translate', [_vm._v("Member")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "count member-color"
  }, [_vm._v(_vm._s(_vm.statistic.accounts || 0))])], 1)])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "graph-panel"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 10,
      "lg": 10
    }
  }, [_c('div', {
    staticClass: "graph-item"
  }, [_c('div', {
    staticClass: "graph-item-header"
  }, [_c('translate', [_vm._v("Resource Type")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.reTypeLoading),
      expression: "reTypeLoading"
    }],
    staticClass: "graph-item-content chart"
  }, [(!_vm.resourceType && !_vm.reTypeLoading) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "110px"
    }
  }, [_c('translate', [_vm._v("No Resource Type")])], 1) : _vm._e(), _vm._v(" "), (_vm.resourceType && !_vm.reTypeLoading) ? _c('nvd3-pie-chart', {
    attrs: {
      "options": _vm.resourceType.options,
      "data": _vm.resourceType.data
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 14,
      "lg": 14
    }
  }, [_c('div', {
    staticClass: "graph-item"
  }, [_c('div', {
    staticClass: "graph-item-header"
  }, [_c('translate', [_vm._v("A Week Operation Statistic")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (!_vm.weekOperation),
      expression: "!weekOperation"
    }],
    staticClass: "graph-item-content chart"
  }, [(_vm.weekOperation) ? _c('nvd3-line-chart', {
    attrs: {
      "options": _vm.weekOperation.options,
      "data": _vm.weekOperation.data
    }
  }) : _vm._e()], 1)])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "graph-panel"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('div', {
    staticClass: "graph-item",
    class: _vm.currentConnectCount > 10 ? 'graph-item-210' : ''
  }, [_c('div', {
    staticClass: "graph-item-header"
  }, [_c('translate', [_vm._v("Online Sessions")])], 1), _vm._v(" "), _c('div', {
    staticClass: "graph-item-content"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (!_vm.currentConnectList),
      expression: "!currentConnectList"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.currentConnectList,
      "empty-text": _vm.attrText.noSession
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "account.name",
      "label": _vm.attrText.member,
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(!scope.row.account ? '' : scope.row.account.name) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "50",
      "label": " "
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.safe_mode) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.attrText.unsafeMode,
            "placement": "top"
          }
        }, [_c('i', {
          staticClass: "fa fa-exclamation-circle warn"
        })]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "project_name",
      "label": _vm.attrText.workgroup
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resource_name",
      "label": _vm.attrText.resource
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action,
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.agentVersion < '3.0.0') ? _c('el-button', {
          attrs: {
            "disabled": !scope.row.linkHref || !(scope.row.way == 'terminal' || scope.row.way == 'wetty' || (scope.row.way == 'rdp' && scope.row.showRdp)),
            "type": "text",
            "target": "_blank"
          },
          on: {
            "click": function($event) {
              _vm.onLinkhref(scope.row.linkHref)
            }
          }
        }, [_c('translate', [_vm._v("Monitor")])], 1) : _vm._e(), _vm._v(" "), (scope.row.agentVersion >= '3.0.0') ? _c('el-button', {
          attrs: {
            "disabled": !(scope.row.way == 'terminal' || scope.row.way == 'wetty' || (scope.row.way == 'rdp' && scope.row.showRdp)),
            "type": "text",
            "target": "_blank"
          }
        }, [(scope.row.way === 'terminal' || scope.row.way === 'wetty') ? _c('span', {
          on: {
            "click": function($event) {
              _vm.createShadow(scope.row)
            }
          }
        }, [_c('translate', [_vm._v("assistance")])], 1) : _vm._e(), _vm._v(" "), ((scope.row.way === 'rdp' && scope.row.showRdp)) ? _c('span', {
          on: {
            "click": function($event) {
              _vm.onLinkhref(scope.row.linkHref)
            }
          }
        }, [_c('translate', [_vm._v("monitor")])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.onCutOnline(scope.row)
            }
          }
        }, [_c('translate', [_vm._v("Disconnect")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.currentConnectCount > 10) ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next",
      "total": _vm.currentConnectCount,
      "page-size": 10,
      "current-page": _vm.currentConnectPage
    },
    on: {
      "update:currentPage": function($event) {
        _vm.currentConnectPage = $event
      },
      "current-change": _vm.onChangePage
    }
  })], 1) : _vm._e()], 1)])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 6,
      "lg": 6
    }
  }, [_c('div', {
    staticClass: "graph-item"
  }, [_c('div', {
    staticClass: "graph-item-header"
  }, [_c('translate', [_vm._v("A Week TOP Member")])], 1), _vm._v(" "), _c('div', {
    staticClass: "graph-item-content"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (!_vm.topMembers),
      expression: "!topMembers"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.topMembers
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.attrText.member
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('span', {
          staticClass: "photo clearfix"
        }, [_c('img', {
          attrs: {
            "src": _vm._f("resetURL")(props.row.avatar),
            "border": "0"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(props.row.name))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.duration,
      "width": "110",
      "class-name": "text-right",
      "label-class-name": "text-right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.conn_time) + "\n                ")]
      }
    }])
  })], 1)], 1)])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 6,
      "lg": 6
    }
  }, [_c('div', {
    staticClass: "graph-item"
  }, [_c('div', {
    staticClass: "graph-item-header"
  }, [_c('translate', [_vm._v("A Week TOP Resource")])], 1), _vm._v(" "), _c('div', {
    staticClass: "graph-item-content"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (!_vm.topResources),
      expression: "!topResources"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.topResources
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": _vm.attrText.resource,
      "min-width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "conn_count",
      "label": _vm.attrText.number,
      "class-name": "text-right",
      "label-class-name": "text-right"
    }
  })], 1)], 1)])])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2938854b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/operations/dashboard.vue
// module id = 543
// module chunks = 4 5 6